import { Link } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import { useState } from 'react';
// import logoBlack from "../../assets/gt-home logo.svg";
import logoBlack from "../../assets/logo.svg";



function NavEn({ url }) {
  const [open, setOpen] = useState(false);

  const handelClick = () => {
    setOpen(!open);
  };

  return (
    <nav>
      <div className="nav-logo">
        <img src={logoBlack} className="app-logo" alt="logo" />
      </div>

      <div className="nav-bottom" onClick={handelClick}>
        <FaBars />
      </div>

      {open && (
        <div className="nav-content">
          <Link to="/" onClick={handelClick}>
            Home
          </Link>
          <Link to="/projects" onClick={handelClick}>
            Projects
          </Link>
          <Link to="/properties" onClick={handelClick}>
            Properties
          </Link>
          {/* <a href="/#contact-sec" onClick={handelClick}>
            Contact
          </a> */}
          <Link to="/#contact-sec" onClick={handelClick}>
            Contact
          </Link>
          <Link className="lang" to={url} onClick={handelClick}>
            AR
          </Link>
        </div>
      )}

      <div className="long-nav">
          <Link to="/">
            Home
          </Link>
          <Link to="/projects">
            Projects
          </Link>
          <Link to="/properties">
            Properties
          </Link>
          <Link to="/#contact-sec">
            Contact
          </Link>
          <Link className="lang" to={url}>
            AR
          </Link>
      </div>
    </nav>
  );
}

export default NavEn;
